import {
  OPENINGGIFTDETAILS_LOAD,
  OPENINGGIFTDETAILS_LOAD_SUCCESS,
  OPENINGGIFTDETAILS_LOAD_FAIL,
  // CLOSINGGIFTDETAILS_LOAD,
  // CLOSINGGIFTDETAILS_LOAD_SUCCESS,
  // CLOSINGGIFTDETAILS_LOAD_FAIL,
  SETOPENINGGIFTFOREVENT_LOAD,
  SETOPENINGGIFTFOREVENT_LOAD_SUCCESS,
  SETOPENINGGIFTFOREVENT_LOAD_FAIL,
} from './actions';

const initialState = {
  loaded: false,
  editing: {},
  saveError: {},
  // data: [],
  // extraData: {},
  setOpeningGiftForEvent: {},
  openingGift: null,
  // closingGiftDetails: null,
};
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case OPENINGGIFTDETAILS_LOAD:
      return {
        ...state,
        loading: true,
      };
    case OPENINGGIFTDETAILS_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case OPENINGGIFTDETAILS_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };

    // case CLOSINGGIFTDETAILS_LOAD:
    //   return {
    //     ...state,
    //     loading: true,
    //   };
    // case CLOSINGGIFTDETAILS_LOAD_SUCCESS:
    //   return {
    //     ...state,
    //     loading: false,
    //     loaded: true,
    //     closingGiftDetails: action.result,
    //     error: null,
    //     extraData: 'This is extra info..........',
    //   };
    // case CLOSINGGIFTDETAILS_LOAD_FAIL:
    //   return {
    //     ...state,
    //     loading: false,
    //     loaded: false,
    //     closingGiftDetails: null,
    //     error: action.error,
    //   };

    case SETOPENINGGIFTFOREVENT_LOAD:
      return {
        ...state,
        loading: true,
      };
    case SETOPENINGGIFTFOREVENT_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data1: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case SETOPENINGGIFTFOREVENT_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data1: null,
        error: action.error,
      };


    default:
      return state;
  }
}
